module.exports = __webpack_public_path__ + "media/images/map-bkg-1818206bfe8127bf8575a70ce8322e9b.png";